import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeEntreprise } from 'src/app/shared/models/typeEntreprise';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeEntrepriseModalAjoutComponent } from '../modal/typeEntreprise-modal-ajout/typeEntreprise-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeEntrepriseModalDetailComponent } from '../modal/typeEntreprise-modal-detail/typeEntreprise-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeEntreprise',
	templateUrl: './list-typeEntreprise.component.html',
	styleUrls: ['./list-typeEntreprise.component.scss']
})
export class ListTypeEntrepriseComponent implements OnInit {
	typeEntreprise: TypeEntreprise[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeEntrepriseCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeEntrepriseModalRef: BsModalRef;
	addTypeEntrepriseModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeEntreprise();
		this.isAddable = true;
	}

	getTypeEntreprise(): void {
		this.isListingLoading = true;
		this.facade.typeEntrepriseService.getAllTypeEntreprise().subscribe({
			next: (val) => {
				this.typeEntreprise = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeEntreprise.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeEntreprise = [];
			}
		});
	}

	selectTypeEntreprise(typeEntreprise: TypeEntreprise): void {
		const link = ['/typeEntreprise', typeEntreprise.id];
		this.router.navigate(link);
	}

	importTypeEntreprise(event: any): void {
		this.typeEntrepriseCsvFile = event.target.files[0];

		this.facade.typeEntrepriseService
			.importTypeEntreprise(this.typeEntrepriseCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeEntreprise ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeEntreprise();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeEntrepriseModalRef = this.modalService.show(
			TypeEntrepriseModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeEntrepriseModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeEntreprise();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeEntreprise: TypeEntreprise) {
		const initialState = {
			typeEntreprise: typeEntreprise
		};
		this.editTypeEntrepriseModalRef = this.modalService.show(
			TypeEntrepriseModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeEntrepriseModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeEntreprise();
		});
	}
}
